{
  "title": "Настройки",
  "landing": {
    "interface": "Настройки интерфейса",
    "interfaceDesc": "Язык, тема и цвет",
    "hotkeys": "Горячие клавиши",
    "hotkeysDesc": "Сочетания клавиш"
  },
  "actions": {
    "reset": "Сбросить по умолчанию",
    "cancel": "Отмена",
    "save": "Сохранить"
  },
  "saved": "Сохранено",
  "error": "Произошла ошибка",
  "resetTitle": "Вернуть настройки по умолчанию?",
  "resetText": "Язык, тема, основной цвет и вид вернутся к значениям по умолчанию. Чтобы сохранить, нажмите «Сохранить».",
  "resetConfirm": "Сбросить",
  "unsavedTitle": "Изменения не сохранены",
  "unsavedText": "Несохранённые изменения будут отменены.",
  "stay": "Остаться",
  "leave": "Выйти",
  "interface": {
    "title": "Настройки интерфейса",
    "language": "Язык",
    "languageDesc": "Тексты интерфейса и формат дат отображаются на выбранном языке",
    "languages": {
      "uz-Latn": {
        "name": "O'zbekcha",
        "sub": "Lotin yozuvi"
      },
      "uz-Cyrl": {
        "name": "Ўзбекча",
        "sub": "Кирилл ёзуви"
      },
      "ru": {
        "name": "Русский",
        "sub": "Русский язык"
      },
      "en": {
        "name": "English",
        "sub": "English"
      }
    },
    "theme": "Тема",
    "themeDesc": "Светлый или тёмный режим. «Системная» следует настройке устройства",
    "themes": {
      "light": "Светлая",
      "dark": "Тёмная",
      "system": "Системная"
    },
    "accent": "Основной цвет",
    "accentDesc": "Применяется к кнопкам, активной вкладке и ссылкам",
    "customHex": "Свой цвет (HEX)",
    "custom": "Свой цвет",
    "accents": {
      "blue": "Синий",
      "green": "Зелёный",
      "darkGreen": "Тёмно-зелёный",
      "yellow": "Жёлтый",
      "orange": "Оранжевый",
      "red": "Красный",
      "pink": "Розовый",
      "purple": "Фиолетовый"
    },
    "view": "Вид",
    "compact": "Компактные таблицы",
    "compactDesc": "Строки ниже — помещается больше данных",
    "animations": "Анимации",
    "animationsDesc": "Плавное появление панелей и окон",
    "fontSize": "Размер текста",
    "fontSizes": {
      "12": "Очень мелкий (12 px)",
      "13": "Мелкий (13 px)",
      "14": "Средний (14 px)",
      "15": "Крупный (15 px)",
      "16": "Очень крупный (16 px)"
    },
    "preview": "Пример",
    "previewDesc": "Посмотрите, как будут выглядеть выбранные тема и цвет",
    "sample": {
      "title": "Все сотрудники",
      "add": "Добавить",
      "in": "Входит",
      "out": "Не входит",
      "viewOnly": "Только просмотр",
      "save": "Сохранить",
      "cancel": "Отмена",
      "active": "Активный сотрудник"
    }
  },
  "hotkeys": {
    "title": "Горячие клавиши",
    "search": "Поиск по действию или клавише",
    "conflicts": "Повторов: {{count}}",
    "columns": {
      "action": "Действие",
      "description": "Описание",
      "combo": "Сочетание",
      "status": "Статус",
      "actions": "Действие"
    },
    "groups": {
      "general": "Общие",
      "drawing": "Чертёж",
      "table": "Таблица"
    },
    "status": {
      "default": "По умолчанию",
      "error": "Ошибка",
      "modified": "Изменено",
      "conflict": "Повторяется",
      "editing": "Редактируется"
    },
    "capture": "Нажмите клавиши...",
    "captureLabel": "Новое сочетание: {{name}}",
    "edit": "Изменить",
    "accept": "Принять",
    "cancelEdit": "Отмена",
    "resetRow": "Вернуть по умолчанию",
    "none": "Не назначено",
    "reserved": "Это сочетание браузера занять нельзя",
    "busy": "Клавиша занята: {{name}}",
    "saved": "Сочетание сохранено",
    "conflictToast": "Сочетание совпадает с действием «{{name}}»",
    "resetAllTitle": "Вернуть все сочетания по умолчанию?",
    "resetAllText": "Все изменённые вами сочетания вернутся к значениям по умолчанию.",
    "resetConfirm": "Сбросить",
    "empty": "Ничего не найдено",
    "emptyHint": "Попробуйте изменить запрос.",
    "toggleGroup": "Свернуть или развернуть группу «{{name}}»",
    "actions": {
      "create": {
        "label": "Создать",
        "description": "Добавить новый элемент"
      },
      "save": {
        "label": "Сохранить",
        "description": "Сохранить изменения"
      },
      "search": {
        "label": "Поиск",
        "description": "Открыть глобальный поиск"
      },
      "cancel": {
        "label": "Отмена",
        "description": "Закрыть окно или отменить действие"
      },
      "refresh": {
        "label": "Обновить",
        "description": "Перезагрузить данные"
      },
      "help": {
        "label": "Справка",
        "description": "Открыть руководство пользователя"
      },
      "zoomIn": {
        "label": "Увеличить",
        "description": "Приблизить чертёж"
      },
      "zoomOut": {
        "label": "Уменьшить",
        "description": "Отдалить чертёж"
      },
      "addDevice": {
        "label": "Добавить устройство",
        "description": "Разместить новое устройство на чертеже"
      },
      "layers": {
        "label": "Слои",
        "description": "Показать меню слоёв"
      },
      "export": {
        "label": "Экспорт",
        "description": "Выгрузить таблицу в Excel"
      },
      "copy": {
        "label": "Копировать",
        "description": "Скопировать выбранные строки"
      },
      "selectAll": {
        "label": "Выделить всё",
        "description": "Отметить все строки"
      },
      "saveChart": {
        "label": "Сохранить график",
        "description": "Сохранить текущий график во вкладку"
      }
    }
  }
}
